import { LoginRequest, LoginResponse } from '@alert-manager/lib';

export const authAPI = {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    try {
      const response = await fetch(`/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          message: data.message || 'Login failed',
        };
      }

      return {
        success: true,
        token: data.token,
        user: data.user,
      };
    } catch {
      return {
        success: false,
        message: 'Network error. Please try again.',
      };
    }
  },

  async register(credentials: LoginRequest): Promise<LoginResponse> {
    try {
      const response = await fetch(`/api/auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          message: data.message || 'Registration failed',
        };
      }

      return {
        success: true,
        token: data.token,
        user: data.user,
        message: data.message,
      };
    } catch {
      return {
        success: false,
        message: 'Network error. Please try again.',
      };
    }
  },

  async validateToken(token: string): Promise<boolean> {
    try {
      const response = await fetch(`/api/auth/validate`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.ok;
    } catch {
      return false;
    }
  },

  async changePassword(currentPassword: string, newPassword: string, token: string): Promise<{ success: boolean; message?: string }> {
    try {
      const response = await fetch(`/api/auth/change-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          currentPassword,
          newPassword,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          success: false,
          message: data.message || 'Password change failed',
        };
      }

      return {
        success: true,
        message: data.message || 'Password changed successfully',
      };
    } catch {
      return {
        success: false,
        message: 'Network error. Please try again.',
      };
    }
  },
};
